import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useCollection } from "@/hooks/useCollection";
import type { MissionContent, MissionPoint } from "@/lib/types";

const missionImage =
  "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20volunteer%20in%20a%20red%20vest%20warmly%20handing%20a%20bag%20of%20fresh%20food%20to%20an%20elderly%20person%20in%20a%20bright%20community%20hall%2C%20soft%20natural%20window%20light%2C%20hopeful%20dignified%20generous%20atmosphere%2C%20clean%20simple%20background%2C%20premium%20humanitarian%20photography%2C%20high%20detail&width=900&height=700&seq=humanity59-mission&orientation=landscape";

export default function Mission() {
  const { items: points } = useCollection<MissionPoint>("mission_points");
  const [content, setContent] = useState<MissionContent | null>(null);

  useEffect(() => {
    supabase
      .from("mission_content")
      .select("*")
      .eq("id", 1)
      .maybeSingle()
      .then(({ data }) => {
        if (data) setContent(data as MissionContent);
      });
  }, []);

  if (!content && points.length === 0) return null;

  const title = content?.title ?? "";
  const intro = content?.intro ?? "";

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="w-full aspect-[9/7] rounded-lg overflow-hidden">
              <img
                src={missionImage}
                alt="Membre d'Humanity59 remettant un panier alimentaire"
                title="Notre mission — Humanity59"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block text-sm font-semibold text-accent-600">
              Notre mission
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              {title}
            </h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              {intro}
            </p>

            <div className="mt-8 space-y-5">
              {points.map((point, index) => (
                <div key={point.title || index} className="flex gap-4">
                  <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className={`${point.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">
                      {point.title}
                    </h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                      {point.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}